import { Radio } from "@material-ui/core";
import { FlyerListCurrentHeaderProps } from "./flyer-list-current-header.props";
import {
  CurrentHeader,
  useFlyerListCurrentHeaderStyles,
  ViewLabel,
} from "./flyer-list-current-header.styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faThLarge } from "@fortawesome/free-solid-svg-icons";

export interface GridListToggleProps {
  gridView: boolean;
  setGridView: (gridView: boolean) => void;
}

export const FlyerListCurrentHeader = (props: FlyerListCurrentHeaderProps) => {
  const classes = useFlyerListCurrentHeaderStyles();

  return (
    <CurrentHeader className={classes.noWrap} variant="h2">
      Current
      <ViewLabel htmlFor="gridView">Grid View</ViewLabel>
      <Radio
        inputProps={{ "aria-label": "Grid View" }}
        id="gridView"
        value="gridView"
        checked={props.gridView}
        style={{ width: "fit-content", marginLeft: "16px" }}
        checkedIcon={<FontAwesomeIcon icon={faThLarge} size="xs" color="deepSkyBlue" />}
        icon={<FontAwesomeIcon icon={faThLarge} size="xs" />}
        onChange={() => props.setGridView(true)}
      />
      <ViewLabel htmlFor="listView">List View</ViewLabel>
      <Radio
        inputProps={{ "aria-label": "List View" }}
        id="listView"
        value="listView"
        checked={!props.gridView}
        style={{ width: "fit-content" }}
        checkedIcon={<FontAwesomeIcon icon={faList} size="xs" color="deepSkyBlue" />}
        icon={<FontAwesomeIcon icon={faList} size="xs" />}
        onChange={() => props.setGridView(false)}
      />
      {/* <GridListToggle {...props} /> */}
    </CurrentHeader>
  );
};
